export const createQueryParams = (params: Record<string, string | number | undefined>) => {
  const queryParams = Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== '')
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  return queryParams ? `?${queryParams}` : '';
};
